import type { CustomFieldOption } from 'src/store/clients/types';

import { formatCustomFieldDate } from './customFieldDate';

export const CHECKBOX_CHECKED_LABEL = 'Yes';
export const CHECKBOX_UNCHECKED_LABEL = 'No';

// Select, checkbox and date store ids, booleans and YYYY-MM-DD strings; contracts print what a person reads.
// Returns undefined for every other type so callers keep their existing handling.
export const getCustomFieldPrintedValue = (
  field: CustomFieldOption,
  rawValue: unknown,
): string | undefined => {
  switch (field.type) {
    case 'select':
      return (
        field.options?.find((option) => option.id === rawValue)?.label ?? ''
      );
    case 'checkbox':
      return rawValue === true
        ? CHECKBOX_CHECKED_LABEL
        : CHECKBOX_UNCHECKED_LABEL;
    case 'date':
      return formatCustomFieldDate(rawValue);
    default:
      return undefined;
  }
};
